export const apihost = () => {
    let hostname = '';
    console.log(`document.location.hostname == ${document.location.hostname}`);
    switch (document.location.hostname) {
        case 'www.kommunal-rapport.no':
            hostname = "https://api.munimeta.kommunal-rapport.red";
            break;
        default:
            hostname = "https://api.munimeta.stage.kommunal-rapport.red";
    }
    return hostname;
};
